import { render, staticRenderFns } from "./RespondChat.vue?vue&type=template&id=723c7ce5&"
import script from "./RespondChat.vue?vue&type=script&lang=js&"
export * from "./RespondChat.vue?vue&type=script&lang=js&"
import style0 from "./RespondChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports